import { gql } from '@apollo/client';

export const GET_STAFF_CHAT_USERS = gql`
  query StaffChatUsers(
    $filter: [FilterMap]
    $pageNo: Int
    $pageSize: Int
    $sortCol: String
    $sortDirection: String
    $pagination: Boolean
  ) {
    staffChatUsers(
      filter: $filter
      pageNo: $pageNo
      pageSize: $pageSize
      sortCol: $sortCol
      sortDirection: $sortDirection
      pagination: $pagination
    ) {
      id
      firstName
      middleName
      lastName
      email
      phone
      profile
      lastMessage
      lastMessageType
      lastMessageAt
      unreadCount
      mediaUrl
    }
  }
`;

export const GET_UNREAD_COUNT = gql`
  query {
    staffChatUnreadCount
  }
`;

export const GET_STAFF_CHAT_MESSAGES = gql`
  query StaffChatMessages($staffId: ID!, $searchTerm: String) {
    staffChatMessages(staffId: $staffId, searchTerm: $searchTerm) {
      id
      senderId
      receiverId
      message
      messageType
      mediaUrl
      isSeen
      createdAt
    }
  }
`;

export const SEND_STAFF_MESSAGE = gql`
  mutation sendStaffInternalMessage($input: StaffChatMessageInput!) {
    sendStaffInternalMessage(input: $input) {
      id
      senderId
      receiverId
      message
      messageType
      createdAt
      isSeen
      mediaUrl
    }
  }
`;

export const MARK_STAFF_CHAT_MESSAGES_AS_SEEN = gql`
  mutation MarkStaffChatMessagesAsSeen($staffId: ID!) {
    markStaffChatMessagesAsSeen(staffId: $staffId) {
      message
      updatedCount
    }
  }
`;

/* ─── Group Chat Operations ────────────────────────────────────────── */
export const GET_STAFF_CHAT_GROUPS = gql`
  query GetStaffChatGroups {
    getStaffChatGroups {
      groupId
      name
      description
      createdById
      memberCount
      unreadCount
      lastMessage
      lastMessageAt
      createdAt
      members {
        userId
        isAdmin
        isActive
        joinedAt
      }
    }
  }
`;

export const CREATE_STAFF_CHAT_GROUP = gql`
  mutation CreateStaffChatGroup($input: CreateStaffChatGroupInput!) {
    createStaffChatGroup(input: $input) {
      groupId
      name
      description
      createdById
      memberCount
      unreadCount
      createdAt
      members {
        userId
        isAdmin
        isActive
        joinedAt
      }
    }
  }
`;

export const GET_STAFF_CHAT_GROUP_MESSAGES = gql`
  query GetStaffChatGroupMessages($groupId: ID!, $page: Int, $size: Int) {
    getStaffChatGroupMessages(groupId: $groupId, page: $page, size: $size) {
      content {
        messageId
        groupId
        senderId
        message
        messageType
        mediaUrl
        isDeleted
        createdAt
        seenCount
        totalMembers
      }
      totalElements
      totalPages
      number
      size
      first
      last
      empty
    }
  }
`;

export const SEND_STAFF_CHAT_GROUP_MESSAGE = gql`
  mutation SendGroupMessage($input: SendStaffChatGroupMessageInput!) {
    sendStaffChatGroupMessage(input: $input) {
      messageId
      groupId
      senderId
      message
      messageType
      mediaUrl
      isDeleted
      createdAt
      seenCount
      totalMembers
    }
  }
`;
